import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs sm:text-sm font-sans font-semibold tracking-[0.22em] uppercase ${
      dark ? "text-[#e8c78f]" : "text-[#a37d3f]"
    }`}
  >
    <span className={`h-px w-8 ${dark ? "bg-[#e8c78f]" : "bg-[#c99a43]"}`} />
    {children}
  </span>
);

export const Chapter = ({ num, label, dark = false }) => (
  <Reveal className="flex items-baseline gap-4">
    <span
      className={`font-serif italic text-lg sm:text-xl ${
        dark ? "text-[#e8c78f]" : "text-[#c99a43]"
      }`}
    >
      {num}
    </span>
    <Eyebrow dark={dark}>{label}</Eyebrow>
  </Reveal>
);
